import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=8ed98c7a&lang=pug"
import script from "./ReportsList.vue?vue&type=script&lang=ts"
export * from "./ReportsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ed98c7a')) {
      api.createRecord('8ed98c7a', component.options)
    } else {
      api.reload('8ed98c7a', component.options)
    }
    module.hot.accept("./ReportsList.vue?vue&type=template&id=8ed98c7a&lang=pug", function () {
      api.rerender('8ed98c7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/ReportsList.vue"
export default component.exports